export const config1 = {
	language: 'id',
	toolbar: [
		"alignment",
		"|",
		"bold",
		"italic",
		"underline",
		"link",
		"|",
		"bulletedList",
		"numberedList",
		"outdent",
		"indent",
		"|",
		"mathType",
		"specialCharacters",
		'insertTable'
	],
	placeholder: "Tulis Soal",
	indentBlock: {
		offset: 1,
		unit: 'em'
	}, table: {
		contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
	},
	specialCharacters: {
		order: [
			'Mathematical',
			'Currency',
			'Arrows',
			'Latin',
			'Text'
		]
	}
};


export const config2 = {
	language: 'id',
	toolbar: [
		"alignment",
		"|",
		"bold",
		"italic",
		"underline",
		"link",
		"|",
		"bulletedList",
		"numberedList",
		"outdent",
		"indent",
		"|",
		"mathType",
		"specialCharacters"
	],
	placeholder: "Tulis Jawaban",
	indentBlock: {
		offset: 1,
		unit: 'em'
	},
	specialCharacters: {
		order: [
			'Mathematical',
			'Currency',
			'Arrows',
			'Latin',
			'Text'
		]
	}
};